const {default: useStore} = require('./use-store.js');

const useEquipments = () => {
    const {store} = useStore();

    return {equipmentStore: store.equipment};
};

export default useEquipments;
